import { defineMessages } from "react-intl"

export const selectCatalogInteriorMessages = defineMessages({
	code: {
		defaultMessage: "Code",
		id: "colors.interior.selectInteriorModal.catalog.code",
	},
	customInterior: {
		defaultMessage: "Choose Custom Interior",
		id: "colors.interior.selectInteriorModal.catalog.customInterior",
	},
	material: {
		defaultMessage: "Material",
		id: "colors.interior.selectInteriorModal.catalog.material",
	},
	name: {
		defaultMessage: "Name",
		id: "colors.interior.selectInteriorModal.catalog.name",
	},
	tag: {
		defaultMessage: "Color group",
		id: "colors.interior.selectInteriorModal.catalog.tag",
	},
})
